// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});



//////////////////
// WEBPACK FOOTER
// /var/www/smartbuy.ru/~/babel-runtime/~/core-js/library/modules/es6.object.get-prototype-of.js
// module id = 587
// module chunks = 23 41